import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/plan/deprecate/license.plan.deprecation.set.mutation.gql"
import type {
  LicensePlanDeprecationSetMutation,
  LicensePlanDeprecationSetMutationVariables,
} from "@/v2-backoffice-client/license/plan/deprecate/__types__/license.plan.deprecation.set.mutation"

type Options = MutationHookOptions<
  LicensePlanDeprecationSetMutation,
  LicensePlanDeprecationSetMutationVariables
>

export function useLicensePlanDeprecationSetMutation(options?: Options) {
  return useMutation<
    LicensePlanDeprecationSetMutation,
    LicensePlanDeprecationSetMutationVariables
  >(mutation, options)
}
